import {EventFilter, EventFilterGroup} from '@/views/storyboard/utils/chartConstants';

export function flattenEventFilters(group: EventFilterGroup | undefined): EventFilter[] {
    if (!group) {
        return [];
    }

    return [
        ...(group.core || []),
        ...(group.prioritised || []),
        ...(group.non_prioritised || []),
        ...(group.others || []),
    ];
}
